import { ReactNode } from "react";
import { IconMoodSad } from "@tabler/icons-react";
import { ActionableMessage } from "./ActionableMessage";

interface Props {
    className?: string;

    title: string;
    message?: ReactNode;

    monoMessage?: string;

    action?: ReactNode;

    errorObj?: Error;
}

/** Sits where the screen's contents would, under a bar and heading that stay (F8) */
export const ErrorScreen = (props: Props) => <ActionableMessage icon={IconMoodSad} {...props} />;
